export default __webpack_public_path__ + "static/play-agent2-bop-hindi-ba8a10ebf9af84513ad1315460a62235.png";